/**
 * Auftritt „nur Betrieb zeigen“ auf den Kundenseiten: Browser-Tab (Titel, Favicon) und Home-Bildschirm-Icon
 * sollen den Betrieb zeigen, nicht AnmeldeMeister. Aus dem (meist breiten) Logo wird dafür ein quadratisches
 * Icon auf weißem Grund erzeugt.
 */

export async function quadratischesIcon(logo: string, groesse = 512): Promise<string | null> {
  try {
    // onload statt decode(): decode() wartet in Hintergrund-Tabs teils endlos. Nach 3 s ohne Icon weiter.
    const bild = new Image();
    await new Promise<void>((fertig, fehler) => {
      const zeit = window.setTimeout(() => fehler(new Error("Zeitüberschreitung")), 3000);
      bild.onload = () => {
        window.clearTimeout(zeit);
        fertig();
      };
      bild.onerror = () => {
        window.clearTimeout(zeit);
        fehler(new Error("Logo nicht lesbar"));
      };
      bild.src = logo;
    });
    const canvas = document.createElement("canvas");
    canvas.width = groesse;
    canvas.height = groesse;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, groesse, groesse);
    const rand = groesse * 0.1;
    const skala = Math.min((groesse - 2 * rand) / bild.width, (groesse - 2 * rand) / bild.height);
    const b = bild.width * skala;
    const h = bild.height * skala;
    ctx.drawImage(bild, (groesse - b) / 2, (groesse - h) / 2, b, h);
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
}

/** Setzt Titel und Icons der Seite; liefert eine Funktion, die den alten Zustand wiederherstellt. */
export function seitenMarkeSetzen(titel: string, icon: string | null): () => void {
  const alterTitel = document.title;
  document.title = titel;
  const geaendert: { el: HTMLLinkElement; href: string }[] = [];
  if (icon) {
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((el) => {
      geaendert.push({ el, href: el.href });
      el.href = icon;
      el.removeAttribute("type");
    });
  }
  return () => {
    document.title = alterTitel;
    geaendert.forEach(({ el, href }) => {
      el.href = href;
    });
  };
}
